import React, { Component, createRef } from 'react';
import { IComment } from '../../core/models/comment';
import { User } from '../../core/models/user';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { REMOVE_COMMENT, UPDATE_COMMENT } from '../../core/handlers.actions';
import { Button, IconButton, Popover, Tooltip, Typography, withStyles } from '@material-ui/core';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

moment.updateLocale('en', {
    relativeTime: {
        future: 'in %s',
        past: '%s', // you can add ago if needed in the context
        s: (number, withoutSuffix) => withoutSuffix ? 'now' : 'a few seconds',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1mth',
        MM: '%dmth',
        y: '1y',
        yy: '%dy'
    }
});

const styles = (theme: any) => ({
    buttonMoreActions: {
        fontSize: '12px'
    },
    commentAvatar: {
        height: '20px',
        width: '20px',
        marginTop: theme.spacing(.5)
    },
    moreActionButton: {
        position: 'absolute' as any,
        right: '-20px',
        top: '-5px'
    }
});

interface Props {
    comment: IComment;
    user: User;
    updateComment: (data: any) => void;
    deleteComment: (commentId: string) => void;
    classes: any;
}

interface State {
    commentText: string | null;
    commentActionsOpen: boolean;
    commentActionsId: string | null;
    commentActionElement: any;
    commentToEdit: IComment | null;
    commentReadyToEdit: boolean;
}

class Comment extends Component<Props, State> {
    postCommentElementEdit = createRef<any>();
    state: State = {
        commentText: null,
        commentActionsOpen: false,
        commentActionsId: null,
        commentActionElement: null,
        commentToEdit: null,
        commentReadyToEdit: false
    }

    constructor(props: Props) {
        super(props);
        this.commentTextHandler = this.commentTextHandler.bind(this);
        this.editComment = this.editComment.bind(this);
        this.commentUpdate = this.commentUpdate.bind(this);
        this.resizeCommentBox = this.resizeCommentBox.bind(this);
    }

    public resizeCommentBox(e:any){
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
    }

    public commentTextHandler(e: any) {
        const { name, value } = e.target;
        this.setState({ ...this.state, [name]: value });
    }

    public commentUpdate(e: React.MouseEvent<HTMLButtonElement>) {
        const { updateComment } = this.props;
        const { commentToEdit, commentText } = this.state;
        (commentToEdit as any).comment = commentText;
        updateComment(commentToEdit);
        this.setState({ ...this.state, commentActionsOpen: false, commentActionsId: null, commentText: null });
    }

    public editComment() {
        const { comment } = this.props;
        this.setState({ ...this.state, commentToEdit: comment, commentReadyToEdit: true, commentActionsOpen: false, commentActionElement: null });
    }

    public render() {
        const { comment, classes, user, deleteComment } = this.props;
        const { commentActionsId, commentReadyToEdit, commentActionsOpen, commentActionElement} = this.state;
        return (
            <div>
                <Typography variant="body2" component="div" className="comment-holder">
                    <AccountCircleOutlinedIcon className={classes.commentAvatar} />
                    {comment._id === commentActionsId && commentReadyToEdit ? (
                        <div>
                            <div className="textarea-comment-wrapper">
                                <div className="text-area">
                                    <textarea 
                                        ref={this.postCommentElementEdit}
                                        onChange={this.commentTextHandler}
                                        name="commentText" 
                                        rows={1} 
                                        maxLength={200}
                                        placeholder="Add Comment" 
                                        defaultValue={comment.comment || ''}></textarea>                                                 
                                </div>
                            </div>
                            <Button className={classes.buttonMoreActions} color="secondary" onClick={this.commentUpdate}>Update</Button>
                            <Button className={classes.buttonMoreActions} color="secondary" onClick={() => this.setState({ ...this.state, commentActionsOpen: false, commentActionsId: null, commentActionElement: null, commentReadyToEdit: false })}>Cancel</Button>
                        </div>
                    ) :
                        <div>
                            <span className="comment-time"><strong>Anonymous</strong>  {moment(comment.createdAt).fromNow()}</span>
                            <Typography variant="body2" component="p" className="comment-text">{comment.comment}</Typography>
                        </div>
                    }
                    {user.id === comment.userId ? (
                        <Tooltip title="more actions" className={classes.moreActionButton}>
                            <IconButton onClick={(e: React.MouseEvent<HTMLButtonElement>) => this.setState({ ...this.state, commentActionsOpen: !commentActionsOpen, commentActionsId: comment._id || '', commentActionElement: e.currentTarget })}>
                                <MoreVertIcon />
                            </IconButton>
                        </Tooltip>
                    ) : null}
                </Typography>

                <Popover
                    id={commentActionsId || ''}
                    open={commentActionsOpen}
                    onClose={() => this.setState({ ...this.state, commentActionsOpen: false, commentActionsId: null, commentActionElement: null })}
                    anchorEl={commentActionElement}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'bottom', horizontal: 'center', }}>
                    <Tooltip title="edit comment">
                        <IconButton onClick={() => this.editComment()}>
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="delete comment">
                        <IconButton onClick={() => { deleteComment(commentActionsId || ''); this.setState({ ...this.state, commentActionsOpen: false, commentActionsId: null, commentActionElement: null }) }}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </Popover>
            </div>
        );
    }
}

const mapProps = (app: any) => ({ user: app.rootReducer.user });
const mapDispatch = (dispatch: Dispatch) => ({
    updateComment: (data: any) => dispatch({ type: UPDATE_COMMENT, payload: data }),
    deleteComment: (commentId: any) => dispatch({ type: REMOVE_COMMENT, payload: commentId })
});

export default connect(mapProps, mapDispatch)(withStyles(styles)(Comment));